import common from "../common";

export default class TutorialFinger extends PIXI.Container {
    constructor(position, timer, repeatNumber, texture = null) {
        super();

        this._view = new PIXI.Sprite(P3.assets.texture(texture || 'tutorial_hand'));
        this._view.anchor.set(0.5);
        this._view.scale.set(0.8);
        this._view.position.set(position.x, position.y);
        this.addChild(this._view);

        this._steps = [];
        this._clickDownTween = null;
        this._clickUpTween = null;
        this._timer = timer;
        this._resetTime = this._timer;
        this._tweens = new P3.utils.TWEEN.Group();
        this._repeatNumber = repeatNumber || 1;
        this._repeatNumberReset = this._repeatNumber;
        this._resetPosition = position;

        this.clickTweens();
    }

    addDownClick(){

    }

    clickDown(){
        let down = new P3.utils.TWEEN.Tween(this._view)
            .to({
                rotation: common.deg2rad(-35)
            }, 500)
            .easing(P3.utils.TWEEN.Easing.Linear.None)
            .delay(500);
        this.addStep(down);
    }

    clickUp(){
        let up = new P3.utils.TWEEN.Tween(this._view)
            .to({
                rotation: common.deg2rad(0)
            }, 500)
            .easing(P3.utils.TWEEN.Easing.Linear.None)
            .delay(0);
        this.addStep(up);
    }

    clickTweens(){
        let self = this;
        this._clickDownTween = new P3.utils.TWEEN.Tween(this._view)
            .to({
                rotation: common.deg2rad(-35)
            }, 500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.In)
            .delay(500);

        this._clickUpTween = new P3.utils.TWEEN.Tween(this._view)
            .to({
                rotation: common.deg2rad(0)
            }, 500)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .delay(0);
    }

    addStep(tween){
        this._steps.push(tween);
    }

    play(){
        this._view.visible = true;
        for (let i = 0; i < this._steps.length; i++) {
            const step = this._steps[i];
            if(i !== this._steps.length -1)
                step.chain(this._steps[i + 1]);
            else{
                let self = this;
                step.onComplete(function () {
                    self.reset();
                })
            }
        }
        this._steps[0].start();
        this._timer = this._resetTime;
        this._turnedOff = false;
    }

    update(){
        if(this._repeatNumber === -1 && !this._turnedOff) return;
        this._timer -= P3.Ticker.dt;
        if(this._timer < 0){
            this.play();
        }
    }

    destroy(){
        this._tweens.removeAll();
    }

    turnOff(){
        this._turnedOff = true;
        this._view.rotation = 0;
        this._view.visible = false;
        this._view.position.set(this._resetPosition.x, this._resetPosition.y);
        for (let i = 0; i < this._steps.length; i++) {
            const step = this._steps[i];
            step.stop();
        }
        this._timer = this._resetTime;
        this._repeatNumber = this._repeatNumberReset;
    }

    reset(){
        if(this._repeatNumber === -1){
            this._view.rotation = 0;
            this._view.position.set(this._resetPosition.x, this._resetPosition.y);
            this._steps[0].start();
        }
        else{
            this._repeatNumber--;
            if(this._repeatNumber > 0){
                this._view.rotation = 0;
                this._view.position.set(this._resetPosition.x, this._resetPosition.y);
                this._steps[0].start();
            }
            else{
                this.turnOff();
            }
        }
    }

    addDelay(delay){
        let self = this;
        let delayTween = new P3.utils.TWEEN.Tween(this._view, this.tweens)
            .to({}, 0)
            .easing(P3.utils.Easing.Back2.Out)
            .delay(delay);
        this.addStep(delayTween);
    }

    fade(fadeIn, time, destroy){
        fadeIn && (this._view.alpha = 0);
        let fadeTween = new P3.utils.TWEEN.Tween(this._view, this.tweens)
            .to({alpha: fadeIn ? 1 : 0}, time)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);
        if(destroy){
            this.destroy();
        }else{
            this.addStep(fadeTween);
        }

    }
}
